import React, { ReactNode } from 'react';
import BrandLogo from './BrandLogo';

interface AuthLayoutProps {
  title: string;
  subtitle: string;
  children: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ title, subtitle, children }) => (
  <div className="gp-auth-page min-h-screen flex items-center justify-center px-4 py-8">
    <div className="w-full max-w-md gp-animate-in">
      <div className="text-center mb-5">
        <div className="flex justify-center mb-3">
          <BrandLogo to="/" size="md" />
        </div>
        <h1 className="font-display text-xl font-semibold mb-1" style={{ color: 'var(--gp-ink)' }}>
          {title}
        </h1>
        <p className="gp-text-muted text-sm">{subtitle}</p>
      </div>
      <div className="gp-card p-5">{children}</div>
    </div>
  </div>
);

export default AuthLayout;
